exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-key[data-v-47675954]{display:-webkit-box;display:-ms-flexbox;display:flex}.table-key .table-key-input[data-v-47675954]{-webkit-box-flex:1;-ms-flex:1;flex:1}.text-left[data-v-47675954] .el-input__inner{text-align:left !important}\n", ""]);

// exports
